<template>
  <div class="line-item" v-if="coverageIteration && missionGlobal"> 
      <!-- {{ coverageIteration.COV_PROCESSING_STATE }} -->
      <div class="heading ml-2" style="display:flex;" @dblclick="refreshResult" @click.stop.prevent="$store.myActions.UI_SET_MEASURETOOL('NONE');">                
        <!-- <v-btn class="mx-0" small icon @click.prevent="$store.myActions.UI_TOGGLE_MISSION_MAP_VISIBILITY({missionId:mission.id,uiid:''})" :title="$t(missionMapVisibility[mission.id]?'Pilot.MissionDrawer.HideMissionTooltip':'Pilot.MissionDrawer.ShowMissionTooltip')"><v-icon>{{missionMapVisibility[mission.id]?'mdi-eye':'mdi-eye-off'}}</v-icon></v-btn> -->
        <v-btn class="missionbtn mx-0 pr-2" :class="{'red--text darken-3':isError}" flat @click.prevent="toggleDetailVisibility()"  :title="$t(isDetailVisible?'Pilot.MissionDrawer.HideMoreMissionInfosTooltip':'Pilot.MissionDrawer.ShowMoreMissionInfosTooltip')" >          
          <v-progress-circular v-if="isRunning" class="mr-2" :rotate="360" indeterminate color="primary" :size="18" :width="2" ></v-progress-circular>
          {{ coverageIterationName }}  
          <v-icon :class="{rotate180:isDetailVisible}" style="margin-left:auto">mdi-chevron-down</v-icon>
        </v-btn>        
        <v-btn class="mx-0" small icon  @click.prevent="selectCoverageIterationResult()" :title="$t('Pilot.MissionDrawer.SelectMissionTooltip')"><v-icon :class="{active:coverageIteration.id == coverageState.selectedCoverageId}">mdi-crosshairs-gps</v-icon></v-btn>                
        <v-btn class="mx-0" small icon flat @click.stop.prevent="deleteCoverageIteration()" ><v-progress-circular class="ml-2"  :size="20" v-if="deleting" indeterminate color="white"></v-progress-circular><v-icon v-else>mdi-delete</v-icon></v-btn>
        <v-btn class="mx-0" small :loading="setttingAsTemplate" icon flat @click="setAsTemplate()" :title="missionGlobal.config.templateSimId == coverageIteration.id?$t('Pilot.MissionDrawer.IsTemplateRefTooltip'):$t('Pilot.MissionDrawer.SetAsTemplateRefTooltip')" ><v-icon  :class="{active:missionGlobal.config.templateSimId == coverageIteration.id}">mdi-check-decagram-outline</v-icon></v-btn>
        
      </div>      
      <v-expand-transition>                              
        <coverage-iteration-line-detail class="mx-1 mb-2 px-2 pb-2 pt-0"  v-if="isDetailVisible" :coverage-iteration="coverageIteration" :uiid="uiid" />
      </v-expand-transition>
  </div> 
</template>
<script lang="ts">


import { AloDbMission } from '@/models/alodb/AloDbMission'
import Vue from 'vue'
import Component from 'vue-class-component'
import { buildSimulationUIStateId,SimulationUiState } from '@/models/ui/SimulationUiState'
import { MapUiState } from '@/models/ui/MapUiState'
import { AloMission } from '@/models/alo/AloMission'
import { AloDbMissionVirtual } from '@/models/alodb/AloDbMissionVirtual'
import MissionColor from '@/components/mission/MissionColor.vue'
import { AloDbMissionGlobal } from '@/models/alodb/AloDbMissionGlobal'
import { buildMissionPlanStateId } from '@/models/ui/MissionPlanUiState'
import { VuetifyConfirmObject } from 'vuetify-confirm'
import { AloDbCoverageIteration } from '@/models/alodb/AloDbCoverageIteration'
import { CoverageState, getCoverageState } from '@/enum/CoverageState'
import { buildCoverageStateId } from '@/models/ui/CoverageUiState'
import CoverageIterationLineDetail from '@/components/smart/Coverage/CoverageIterationLineDetail.vue'
import { Watch } from 'vue-property-decorator/lib'

@Component({
name: 'CoverageIterationLine',  
props:{  
  coverageIteration:{
    type:Object,
    required:true
  },  
  uiid:{
      type: String,
      required: true
  }
},
components:{CoverageIterationLineDetail}
})
export default class CoverageIterationLine extends Vue {      
  
  uiid!:string
  coverageIteration!:AloDbCoverageIteration

  setttingAsTemplate = false
  deleting = false
  
  
  //le composant n'est utilisé que si une missionGlobal est sélectionnée
  get missionGlobal() {  
   return this.$store.myGetters.modifiedAdmMissionGlobal
  }

  get coverage_uiid() {
    return buildCoverageStateId(this.missionGlobal.MIG_ID!,"detail")
  }

  get coverageState() {     
    return this.$store.myGetters.coverageStateByUiid(this.coverage_uiid)
  }

  get simulation_uiid() {
    return buildSimulationUIStateId(this.missionGlobal.MIG_ID!,"detail")
  }

  get map_uiid() {
    return buildSimulationUIStateId(this.missionGlobal.MIG_ID!,"map")
  }

  get coverageIterationState() {             
    return this.$store.myGetters.coverageIterationStateByUiid(this.uiid)
  }
  
  get missionMapVisibility() {
    return this.$store.myGetters.missionMapVisibility
  }

  get missionDetailVisibility() {
    return this.$store.myGetters.missionDetailVisibility
  }  

  get isDetailVisible() {
    //@ts-ignore
    return this.$store.myGetters.coverageDetailVisibility[this.coverageIteration.id!]?.at(0) ?? false
  }

  toggleDetailVisibility() {
    this.$set(this.$store.myGetters.coverageDetailVisibility,this.coverageIteration.id!,[!this.isDetailVisible])
  }

  get isError(){
    //return (this.coverageIteration?.result?.error_msg?.length ?? 0) > 0
    return false
  }
    
  get accesPilotReachDetail() {
    return true
  }

  get missionPlanUiid() {
    return buildMissionPlanStateId(this.missionGlobal.MIG_ID || -1,"simulation")
  }

  get isRunning(){
    //TODO ameliorer avec enum
    //return this.coverageIteration && (this.coverageIteration.result.simulation_state == 'running' || ((this.coverageIteration?.result?.simulation_state?.length ?? 0) == 0 && this.coverageIteration.VIM_STATUS >= 0 && this.coverageIteration.VIM_STATUS != 10))
    return getCoverageState(this.coverageIteration?.COV_PROCESSING_STATE) == CoverageState.running
  }
  
  get coverageIterationName(){
    return `${this.missionGlobal?.MIG_LIBELLE} #${this.coverageIteration.COV_ITERATION}`
  }

  selectCoverageIterationResult()  {    
    if(this.coverageIteration?.id) {
      this.$store.myActions.COVERAGEITERATION_SELECT_DETAIL(this.coverageIteration.id!)      
    }    
  }

  setAsTemplate() {
    if(this.missionGlobal.config && this.missionGlobal.config?.templateSimId != this.coverageIteration.id) {      
      this.setttingAsTemplate = true
      this.missionGlobal.config.templateSimId = this.coverageIteration.id
      this.$store.myActions.MISSIONGLOBAL_SAVE_REQUEST().finally(()=> this.setttingAsTemplate = false)      
    }
  }

  refreshResult(){
    if(this.$store.myGetters.isSysAdmin) {      
      this.$store.myActions.COVERAGEITERATION_PROGRESSION_REQUEST({itemId:this.coverageIteration.id!,migTyp:this.missionGlobal.MIG_TYP} )
    }
  }
  
  async deleteCoverageIteration() {
    if(!this.deleting) {
      const answer = await this.$confirm(this.$t('Simulation.DeleteDialogMessage',{name:this.coverageIterationName}).toString(),{title: this.$t('Admin.Warning')} as VuetifyConfirmObject)
      if (answer) {
        //@ts-ignore
        this.deleting = true
        try{          
          await this.$store.myActions.COVERAGEITERATION_DELETE_REQUEST(this.coverageIteration)
        }
        finally{
          this.deleting = false
        }        
      }    
    }
  }
  
}

</script> 

<style>

.rotate180{
  transform: rotate(-180deg);
}

.missionbtn .v-icon{
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1)!important;
}

.testMission{
  font-style: italic;
  color: rgb(128, 128, 128)!important;
}

.line-item{
  border-bottom: 1px solid #eee;  
}
.line-item .active{
  color: #4caf50!important;  
}

.line-item .heading{
  display: flex;
  flex-direction: row;
  align-items: center;  
}

.missionbtn{
  flex:1 0 auto;
}

.missionbtn .v-btn__content{
  justify-content: flex-start;
}

</style>